import React from 'react';
import { orderSessionLabel } from './ordersComponents/orderDisplay';
import { ticketSessionLabel } from '../../utils/sessionTickets';

/** Badge discret pour indiquer le jour / validité d'un billet ou d'une commande. */
export default function SessionBadge({ ticket, order, label, className = '' }) {
    let text = label ?? null;
    if (!text && order) {
        text = orderSessionLabel(order);
    } else if (!text) {
        text = ticketSessionLabel(ticket);
    }

    if (!text) return null;

    return (
        <span
            className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide bg-slate-100 text-slate-600 dark:bg-slate-700/60 dark:text-slate-300 ${className}`}
        >
            {text}
        </span>
    );
}
